import { render, staticRenderFns } from "./ActionPopup.vue?vue&type=template&id=131f90b6&scoped=true"
import script from "./ActionPopup.vue?vue&type=script&lang=js"
export * from "./ActionPopup.vue?vue&type=script&lang=js"
import style0 from "./ActionPopup.vue?vue&type=style&index=0&id=131f90b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131f90b6",
  null
  
)

export default component.exports